<template>
  <el-dialog
    :visible.sync="dialogVisible"
    append-to-body
    :close-on-click-modal='false'
    width="1072px"
    class="c-edit-dialog"
   >
    <cashierdiary-table
       :isEdit="true"
       :dataRow = "dataRow"
       @successSave="successSave"
       @close="dialogVisible = false"
       c_title="修改日记账"
    >
    </cashierdiary-table>
   </el-dialog>
</template>

<script>
  import cashierdiaryTable from "../cashierdiaryTable/index.vue"
  export default {
    components:{
      cashierdiaryTable
    },
    data() {
      return {
        dialogVisible:false,
        dataRow:{}
      }
    },
    methods:{
      successSave(val) {
        this.dialogVisible = false;
        this.$emit('successSave',val);
      },
    }
  }
</script>

<style lang="less">
  .c-edit-dialog {
    .el-dialog__body{
      padding-top: 50px !important;
    }
    .el-dialog__header {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/editTable.vue